<div class="file-upload-container">
  <!-- Drag-and-drop area, ALWAYS visible -->
  <div class="drag-drop-area" 
    (click)="triggerFileInput()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [class.dragging]="isDragging">
    <div class="text-drop-area">
      <lucide-icon name="cloud-upload" [size]="32" color="var(--primary-color-100)"></lucide-icon>
      <p><span>{{ 'fileUpload.dragDrop' | transloco }}</span> {{ 'fileUpload.dragHere' | transloco }}</p>
    </div>
  </div>

  <!-- PrimeNG component to manage files -->
  <p-fileUpload 
    #fileUploadRef
    mode="advanced"
    [customUpload]="true"
    [multiple]="true"
    [showUploadButton]="false"
    [showCancelButton]="false"
    class="custom-file-upload"
    (onSelect)="onFileSelect($event)"
    (uploadHandler)="uploadFiles($event)"
  ></p-fileUpload>

@if (validFiles) {
  <div class="card">
    <p-carousel [value]="files" [numVisible]="2" [numScroll]="1" [circular]="false" [responsiveOptions]="responsiveOptions">
      <ng-template let-file pTemplate="item">
        <div class="border border-surface rounded-border m-2">
          <app-file-item
          [fileName]="file.name"
          [fileSize]="file.size"
          action="delete"
          (remove)="removeFile(file)">
        </app-file-item>
      </div>
    </ng-template>
  </p-carousel>
</div>
}
</div>
